import React from 'react';
import { connect } from 'react-redux';
import { PopoverTransfer } from "../actions/Tippy";
import { SendSocketTransferCallMonitorIn } from '../actions/websocket'
import {ReactComponent as TRANSFERICON} from "../build/images/icons/transfer-client-icon.svg"
import {ReactComponent as TRANSFERICON2} from "../build/images/icons/transfer-client-icon2.svg"
import _ from "lodash";
import {ReactComponent as Arrow } from  "../build/images/account-arrow-right.svg"

let isAddUserSupervisor = true;

function createJSON(item) {
    if(item){
        var mensagem_tratada = item.replace(/¿/gi, "\n");
        mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
        let valor = 1
        try{
        mensagem_tratada = '{"'+valor+'": [{"mensagem_tratada":"'+mensagem_tratada+'"}]}';
        var obj = JSON.parse(mensagem_tratada);
        mensagem_tratada = obj[1][0].mensagem_tratada
        } catch(e){
            mensagem_tratada = item; 
        }
        return mensagem_tratada
    } 
}

const mapStateToProps = state => {
    return {
      UserGroups: state.groups,
      InfoUsers: state.informationusers,
      UsersAgents: state.agents,
      AtdSimult: state.atdsimult, 
      IPCurrent: state.ipcurrent,
    };
};

class TransferClient extends React.Component {

  constructor(props) {
    var storageGroup = localStorage.getItem('atendance_filter_group') || []
    if(storageGroup.length !== 0){
      storageGroup = storageGroup.split(',').map(Number);
    }

    var storageState = localStorage.getItem('atendance_filter_state') || []
    if(storageState.length !== 0){
      storageState = storageState.split(',');
    }

    super(props);
    this.state = {
          isVisibleFilter: false,
          keyGen: storageGroup,
          auxkeyGen: storageGroup,
          keyGan: storageState,
          auxkeyGan: storageState,
          marked: "Marcar Todos",
          checked: false,
          groups: [],
          agents: [],
          agentsinicial: [],
          expandAgent: [],
          showtransfer: 'atendentes',
          atdsimult: [],
          filterAgent: ""
    };
  }

  ChangeVisibleFilter(e) {
    e.preventDefault();
    this.setState({ isVisibleFilter: !this.state.isVisibleFilter });
  }

  changeAgent(e, teste) {
    this.setState({ filterAgent: e.target.value });
    if (e.target.value != "") {
      this.setState({ keyGan: [] });
    }
    if (e.target.value === "") {
      this.setState({ keyGan: this.state.auxkeyGan });
    }
  }

  
  filterGroup(e, idgroup) {
    let filtersgroupstorage = []
    if (e.target.checked) {
      this.setState({
        keyGen: this.state.keyGen.concat([idgroup])
      });
      this.setState({
        auxkeyGen: this.state.auxkeyGen.concat([idgroup])
      });
      filtersgroupstorage = this.state.keyGen.concat([idgroup])
    } else {
      this.setState({
        keyGen: this.state.keyGen.filter(function(val) {
          return val != idgroup;
        })
      });
      this.setState({
        auxkeyGen: this.state.auxkeyGen.filter(function(val) {
          return val != idgroup;
        })
      });
      filtersgroupstorage =  this.state.keyGen.filter(function(val) {return val!=idgroup})
      this.setState({ marked: "Marcar Todos" });
      this.setState({ checked: false });
    }
    localStorage.setItem('atendance_filter_group', filtersgroupstorage)
  }

  filterGroupAll(e, usergroups) {
    var usergroups = usergroups.groups;
    var teste = [];
    if (e.target.checked) {
      this.setState({ checked: true });
      this.setState({ marked: "Desmarcar Todos" });
      var myCheckbox1 = document.getElementById("groups" + "0");
      myCheckbox1.checked = true;
      for (let i = 0; i < usergroups.length; i++) {
        teste.push(usergroups[i].id);
        var myCheckbox = document.getElementById("groups" + usergroups[i].id);
        myCheckbox.checked = true;
      }
      this.setState({
        keyGen: teste
      });
    } else {
      this.setState({ marked: "Marcar Todos" });
      this.setState({ checked: false });
      var myCheckbox1 = document.getElementById("groups" + "0");
      myCheckbox1.checked = false;
      usergroups.map(groups => {
        var myCheckbox = document.getElementById("groups" + groups.id);
        myCheckbox.checked = false;
      });
      this.setState({ keyGen: [] });
    }
  }

  filterState(e, status) {
    let filterstatestorage = []
    if (e.target.checked) {
      filterstatestorage = this.state.keyGan.concat([status])
      if(status === 'AT')
      filterstatestorage = filterstatestorage.concat(['ATOS'])
      this.setState({
        keyGan: filterstatestorage
      });
      this.setState({
        auxkeyGan: filterstatestorage
      });
    } else {
        filterstatestorage =  this.state.keyGan.filter(function(val) {return val!=status})
        if(status === 'AT')
        filterstatestorage = filterstatestorage.filter(function(val) {return val!='ATOS'})
        this.setState({
          keyGan : filterstatestorage
        })
        this.setState({
          auxkeyGan : filterstatestorage
        })
    }
    localStorage.setItem('atendance_filter_state', filterstatestorage)
  }

  TransferAgentMonitor(e,user,agent,UsersAgents){


    SendSocketTransferCallMonitorIn(
      user.id,
      localStorage.getItem('idcdr'),
      agent.iduser,
      agent.iduser,
      localStorage.getItem('serverid'),
      localStorage.getItem('usermon'),
      UsersAgents,
      localStorage.getItem("telcliente")
      );
      this.props.ClosePopovers();
  }

  renderPopover2 = (e, UserGroups, InfoUsers, UsersAgents) => (

    <div id="popover-check-friend" style={{minWidth: '330px'}}>
      <div className="popover">
        <div className="popover__header">
          <i className="fas fa-user"></i>
          <span>Transferir para outro atendente</span>
        </div>
        <div className="popover__body popover__body--full-width">
          <div
            className={
                this.state.isVisibleFilter
                ? "select with-icons with-footer-actions active"
                : "select with-icons with-footer-actions"
            }
          >
            <button
              type="button"
              data-pausa="Atendimento Presencial Cliente"
              onClick={this.ChangeVisibleFilter.bind(this)}
            >
              Filtros{" "}
            </button>
            <div className="options">
              <ul style={{maxHeight: '270px'}}>
                <li>
                  <input
                    type="radio"
                    defaultChecked
                    name="filterGroup"
                    id="filterGroup"
                  />
                  <label htmlFor="filterGroup">Grupo</label>
                </li>
                <li>
                  <hr></hr>
                </li>
                <li>
                  <input
                    type="checkbox"
                    defaultChecked={this.state.keyGan.findIndex(function(val) {return val==='LV'}) !== -1 ? true:false}
                    name="filtro1"
                    onChange={event => this.filterState(event, "LV")}
                    id="filtro1"
                  />{" "}
                  <label htmlFor="filtro1">Usuários Disponíveis</label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    defaultChecked={this.state.keyGan.findIndex(function(val) {return val==='AT'}) !== -1 ? true:false}
                    name="filtro3"
                    onChange={event => this.filterState(event, "AT")}
                    id="filtro3"
                  />{" "}
                  <label htmlFor="filtro3">Usuários em Atendimento</label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    name="filtro4"
                    defaultChecked={this.state.keyGan.findIndex(function(val) {return val==='BQ'}) !== -1 ? true:false}
                    onChange={event => this.filterState(event, "BQ")}
                    id="filtro4"
                  />{" "}
                  <label htmlFor="filtro4">Usuários Pausados</label>
                </li>
                <li>
                  <input
                    type="checkbox"
                    name="filtro5"
                    defaultChecked={this.state.keyGan.findIndex(function(val) {return val==='null'}) !== -1 ? true:false}
                    onChange={event => this.filterState(event, 'null')}
                    id="filtro5"
                  />{" "}
                  <label htmlFor="filtro5">Usuários Deslogados</label>
                </li>
                <li>
                  <hr></hr>
                </li>
                <li>
                  <input
                    type="checkbox"
                    checked={this.state.checked}
                    name="groups0"
                    id="groups0"
                    onChange={event => this.filterGroupAll(event, UserGroups)}
                  />{" "}
                  <label htmlFor="groups0">{this.state.marked}</label>
                </li>
                {this.state.groups.map((group, index) => (
                  <li key={index}>
                    <input
                      type="checkbox"
                      onChange={event => this.filterGroup(event, group.id)}
                      name={"groups" + group.id}
                      id={"groups" + group.id}
                      defaultChecked={this.state.keyGen.findIndex(function(val) {return val===group.id}) !== -1 ? true:false}
                    />{" "}
                    <label htmlFor={"groups" + group.id}>{group.name}</label>
                  </li>
                ))}
                <br />
                <br />
                <a style={{margin: '-10px', width: '107%'}} className="btn btn-secondary" id="apply-filters" onClick={event => this.ChangeVisibleFilter(event)}>Cancelar</a>
              </ul>
            </div>
          </div> 
          <div className="full-search">
            <input
              type="text"
              name="client-search"
              id="client-search"
              onChange={event => this.changeAgent(event, "teste")}
              placeholder="Pesquisar..."
            />
            <button type="submit">
              <i className="fas fa-search"></i>
            </button>
          </div>
          <div className={this.state.showtransfer ? "popover__clientes clts active":"popover__clientes clts"}>
              <div className="list">
                <ul>
                  {this.state.agents.map((agent, index) => (
                    <li key={index}>
                      <div className="photo"></div>
                      <div className="data">
                        <div
                          className="name"
                        >
                          {agent.username}
                        </div>
                        <div
                          className="info"
                          key={agent.id}                                      
                        >
                          <span>
                            <strong>Ramal:</strong> {agent.ramal}
                          </span>
                          <span>
                            <strong>Grupo:</strong> {agent.desc_grupo}
                          </span>
                          {(() => {
                            if (agent.status_sip === null || agent.status === null) {
                              return (
                                <span>
                                  <strong>Status:</strong> Deslogado
                                </span>
                              );
                            } else if (agent.status_sip === "LV" && agent.status === "LV" && agent.razao_bloqueio !== 'GESTOR') {
                              return (
                                <span>
                                  <strong>Status:</strong> Livre
                                </span>
                              );
                            } else if (agent.status_sip === "LV" && agent.status === "AT") {
                              return (
                                <div>
                                  <span>
                                    <strong>Status:</strong> Atendimento
                                  </span>
                                  <span>
                                    <strong>Ocupação:</strong> {agent.direcao} com{" "}
                                    {agent.speaknum}
                                  </span>
                                </div>
                              );
                            } else if (agent.status_sip === "RV" && agent.status === "ATOS") {
                              return (
                                <div>
                                  <span>
                                    <strong>Status:</strong> Atendimento
                                  </span>
                                  <span>
                                    <strong>Ocupação:</strong> {agent.direcao} com{" "}
                                    {agent.speaknum}
                                  </span>
                                </div>
                              );
                            } else if (agent.status_sip === "LV" && agent.status === "RV") {
                              return (
                                <div>
                                  <span>
                                    <strong>Status:</strong> Discando
                                  </span>
                                  <span>
                                    <strong>Ocupação:</strong> {agent.direcao} para{" "}
                                    {agent.speaknum}
                                  </span>
                                </div>
                              );
                            } else if (agent.status_sip === "BQ" && agent.razao_bloqueio != "") {
                              return (
                                <div>
                                  <span>
                                    <strong>Status:</strong> Pausado
                                  </span>
                                  <span>
                                    <strong>Ocupação:</strong> Pausa{" "}
                                    {agent.razao_bloqueio}
                                  </span>
                                </div>
                              );
                            } else if (agent.status_sip === "CHND" && agent.razao_bloqueio != "CHND") {
                              return (
                                <div>
                                  <span>
                                    <strong>Status:</strong> Chamando
                                  </span>
                                  <span>
                                    <strong>Ocupação:</strong> Chamando{" "}
                                    {agent.direcao} do {agent.speaknum}
                                  </span>
                                </div>
                              );
                            }
                          })()}
                        </div>
                      </div>
                      {(() => {
                        if (agent.status_sip === "LV" && agent.status === "LV") {
                          return (
                            <div className="action">
                              <a
                                href="#"
                                data-tooltip-content="Encaminhar conversa"
                                className="tippy-default"
                                onClick={event => this.TransferAgentMonitor(event,InfoUsers,agent,UsersAgents)}
                              >
                                <TRANSFERICON />
                              </a>
                            </div>
                              );
                            } else if (agent.status_sip === "LV" && agent.status === "AT" && JSON.parse(localStorage.getItem('usermon')) !== agent.iduser) {
                              return (
                                <div className="action">
                                  <a
                                    href="#"
                                    data-tooltip-content="Encaminhar conversa"
                                    className="tippy-default"
                                    onClick={event => this.TransferAgentMonitor(event,InfoUsers,agent,UsersAgents)}
                                  >
                                    <TRANSFERICON />
                                  </a>
                                </div>
                              );
                            } else if (agent.status_sip === "AT" && agent.status === "AT" && JSON.parse(localStorage.getItem('usermon')) !== agent.iduser) {
                              return (
                                <div className="action">
                                  <a
                                    href="#"
                                    data-tooltip-content="Encaminhar conversa"
                                    className="tippy-default"
                                    onClick={event => this.TransferAgentMonitor(event,InfoUsers,agent,UsersAgents)}
                                  >
                                    <TRANSFERICON />
                                  </a>
                                </div>
                              );
                            }else if (agent.status_sip === "RV" && agent.status === "ATOS" && JSON.parse(localStorage.getItem('usermon')) !== agent.iduser) {
                              return (
                                <div className="action">
                                  <a
                                    href="#"
                                    data-tooltip-content="Encaminhar conversa"
                                    className="tippy-default"
                                    onClick={event => this.TransferAgentMonitor(event,InfoUsers,agent,UsersAgents)}
                                  >
                                    <TRANSFERICON />
                                  </a>
                                </div>
                              );
                            } else if (agent.status_sip === "LV" && agent.status === "RV" && JSON.parse(localStorage.getItem('usermon')) !== agent.iduser) {
                              return (
                                <div className="action">
                                  <a
                                    href="#"
                                    data-tooltip-content="Encaminhar conversa"
                                    className="tippy-default"
                                    onClick={event => this.TransferAgentMonitor(event,InfoUsers,agent,UsersAgents)}
                                  >
                                    <TRANSFERICON />
                                  </a>
                                </div>
                              );
                            } else if (agent.status_sip === "CHND" && agent.razao_bloqueio != "CHND" && JSON.parse(localStorage.getItem('usermon')) !== agent.iduser) {
                              return (
                                <div className="action">
                                  <a
                                    href="#"
                                    data-tooltip-content="Encaminhar conversa"
                                    className="tippy-default"
                                    onClick={event => this.TransferAgentMonitor(event,InfoUsers,agent,UsersAgents)}
                                  >
                                    <TRANSFERICON />
                                  </a>
                                </div>
                              );
                            } else if (agent.status_sip === "GESTOR" && agent.razao_bloqueio != "GESTOR") {
                              return (
                                <div className="action">
                                  <a
                                    href="#"
                                    data-tooltip-content="Encaminhar conversa"
                                    className="tippy-default"
                                    onClick={event => this.TransferAgentMonitor(event,InfoUsers,agent,UsersAgents)}
                                  >
                                    <TRANSFERICON />
                                  </a>
                                </div>
                              );
                            }
                          })()}
                        </li>
                      ))}
                </ul>
              </div>
          </div>
          </div>
          <br />
          <a className="btn btn-secondary" id="apply-filters" onClick={event => this.props.ClosePopovers()}>Cancelar</a>
        </div>
    </div>
  );

  render() {

    const { UserGroups, InfoUsers, UsersAgents, AtdSimult } = this.props;

    if (UserGroups.length != 0) {
      this.state.groups = UserGroups.groups;
    }

    this.state.atdsimult = AtdSimult;

    const list2 = this.state.atdsimult || [];
    this.state.atdsimult = _.filter(list2, atd => {
      let arrayAtd = [
        atd.cliente,
        atd.telefone,
      ];
      return !_.isEmpty(this.state.filterAgent)
        ? arrayAtd.toString().toLowerCase().indexOf(this.state.filterAgent.toString().toLowerCase()) >
            -1
        : true;
    });

    if (UsersAgents.length != 0) {
      this.state.agents = UsersAgents;
        this.state.agents = [...this.state.agents, {username: InfoUsers.displayname+' - Gestor', id: InfoUsers.id, iduser: InfoUsers.id, id_grupo: InfoUsers.idgroup, status_sip: 'LV', status: 'LV', ramal: InfoUsers.ramal, desc_grupo: InfoUsers.grupo, duration: '00/00/0000 00:00:00-00:00:00', razao_bloqueio: 'GESTOR'}]
      if (this.state.keyGen !="") {
        this.state.agents = this.state.agents.filter(agent =>
          this.state.keyGen.includes(agent.id_grupo)
        );
      }
      if (this.state.keyGan !="") {
        this.state.agents = this.state.agents.filter(agent => this.state.keyGan.includes(agent.status_sip))
        this.state.agents = this.state.agents.filter(agent => this.state.keyGan.includes(agent.status))
      }
    } 

    if(this.state.filterAgent !== ""){
      const list = this.state.agents || [];
      this.state.agents = list;
      this.state.agents = _.filter(list, agent => {
        let arrayAgent = [
          agent.username,
          agent.desc_grupo,
          agent.ramal,
          agent.razao_bloqueio
        ];
        return !_.isEmpty(this.state.filterAgent)
          ? arrayAgent.toString().toLowerCase().indexOf(this.state.filterAgent.toString().toLowerCase()) >
              -1
          : true;
      });
    }

    this.state.agents = _.orderBy(this.state.agents, ['username'],['asc']); // Use Lodash to sort array by 'name'

    return (
      <PopoverTransfer
        trigger="click"
        content={this.renderPopover2(
            this,
            UserGroups,
            InfoUsers,
            UsersAgents
          )}
      >
        <li className="contact-info contact-info--with-action" id="transfer_teste">
        </li>
      </PopoverTransfer>
    );
  }
}

export default connect(
    mapStateToProps,
    null
)(TransferClient);